import { render, staticRenderFns } from "./SiteDataTable.vue?vue&type=template&id=20e7e0dc"
import script from "./SiteDataTable.vue?vue&type=script&lang=js"
export * from "./SiteDataTable.vue?vue&type=script&lang=js"
import style0 from "./SiteDataTable.vue?vue&type=style&index=0&id=20e7e0dc&prod&language=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports